export function DuplicateButton() {
	return <span
		style={{position: 'relative', top: '-.25em', left: '-.125em'}}>
			📄<span style={{position: "absolute", top: ".25em", left: ".25em"}}>📄</span>
	</span>
}